//Hacemos que reconozca la configuración para utilizar
//Firebase en nuestra App, que está en los archivos
/* firebase.js y context.js */
import firebase from './firebase';
import FirebaseContext from './context';
export { FirebaseContext }
export default firebase;